import { c as _c } from "react/compiler-runtime";
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { WEBSITE_API } from '../api/website-api';
import { WebsiteTemplateId } from 'modules/management/website-templates/types/website-templates-interface';
export interface WebsiteTemplateInterface {
  id: WebsiteTemplateId;
  previewUrl: string;
}
export const useWebsiteTemplatesListAll = isFetchAllowed => {
  const $ = _c(6);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher,
    isFetching: isLoading
  } = useFetch(t0);
  let t1;
  if ($[1] !== user) {
    t1 = () => user && [`${WEBSITE_API}/templates/list-all`, RequestModuleEnum.WebsiteTemplates];
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: websitesTemplate
  } = useControlledSwr(t1, fetcher, undefined, isFetchAllowed);
  let t2;
  if ($[3] !== isLoading || $[4] !== websitesTemplate) {
    t2 = {
      websitesTemplate,
      isLoading
    };
    $[3] = isLoading;
    $[4] = websitesTemplate;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};